<template>
  
  <section v-if="variants.v1 === variant" class="tw-relative tw-h-[100svh] tw-flex tw-flex-col tw-justify-end">
    <!-- Background Video / Image -->
    <video
      v-if="isMobileDevice && vars.mobileBackgroundVideo"
      :src="vars.mobileBackgroundVideo"
      class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    />
    <video
      v-else-if="vars.backgroundVideo"
      :src="vars.backgroundVideo"
      class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      autoplay
      loop
      muted
      playsinline
    />
    <NuxtImg
      v-if="vars.mobileBackgroundImage && isMobileDevice"
      :src="vars.mobileBackgroundImage"
      class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      placeholder="blur"
      :lazy="true"
    />
    <NuxtImg
      v-else-if="vars.backgroundImage"
      :src="vars.backgroundImage"
      class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
      placeholder="blur"
      :lazy="true"
    />

    <!-- Overlay -->
    <div class="tw-absolute tw-inset-0 tw-bg-black tw-opacity-25"></div>

    <!-- Content (bottom aligned) -->
    <div
      class="tw-relative tw-z-10 tw-w-full tw-text-white tw-px-4 "
    >
      <!-- Text -->
      <div class="tw-max-w-[72rem] tw-mx-auto tw-mb-2 ">
        <h1 class="!tw-text-white">{{ vars.titleText }}</h1>
        <small class="!tw-text-white tw-mt-2">{{ vars.titleAltText }}</small>
      </div>

      <!-- Buttons -->
      <div class="tw-bg-white tw-text-black tw-w-full tw-mx-auto tw-max-w-[72rem] tw-grid tw-grid-cols-2 md:tw-flex tw-flex-wrap tw-border">
    <nuxt-link
  v-for="(item, index) in items"
  :key="`hero-button-${index}`"
  :to="item.link"
  :external="true"
  class="tw-text-center tw-border tw-border-gray-300
         tw-transition tw-duration-200
         tw-no-underline hover:tw-no-underline
         tw-h-[60px] md:tw-h-[70px] tw-flex tw-items-center tw-justify-center
         hover:tw-bg-[#E4002B] hover:tw-text-white
         tw-w-full md:tw-w-auto"
  :class="{
    'tw-border-l-0': index % 2 !== 0,
    'md:tw-border-l': index !== 0,
    'md:tw-flex-1': true
  }"
>
  {{ item.label }}
</nuxt-link>





      </div>
        <svg
      v-if="bannerText === 2"
      class="tw-z-50 -tw-mx-4"
      width="2100"
      height="80"
      viewBox="0 0 1990 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      
      <rect width="74" height="226" transform="matrix(0 1 1 0 0 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 119.792 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 135.093 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 135.093 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 150.712 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 166.014 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 166.014 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 181.634 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 196.935 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 196.935 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 212.555 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 0.25293 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 15.5542 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 15.5542 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 31.1738 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 46.4756 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 46.4756 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 62.0942 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 77.3955 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 77.3955 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 93.0161 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 105.703 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 105.964 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 212 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 331.792 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 347.093 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 347.093 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 362.712 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 378.014 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 378.014 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 393.634 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 408.935 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 408.935 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 424.555 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 212.253 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 227.554 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 227.554 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 243.174 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 258.476 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 258.476 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 274.094 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 289.396 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 289.396 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 305.016 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 317.703 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 317.964 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 424 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 543.792 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 559.093 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 559.093 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 574.712 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 590.014 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 590.014 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 605.634 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 620.935 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 620.935 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 636.555 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 424.253 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 439.554 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 439.554 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 455.174 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 470.476 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 470.476 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 486.094 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 501.396 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 501.396 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 517.016 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 529.703 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 529.964 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 636 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 755.792 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 771.093 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 771.093 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 786.712 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 802.014 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 802.014 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 817.634 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 832.935 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 832.935 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 848.555 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 636.253 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 651.554 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 651.554 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 667.174 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 682.476 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 682.476 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 698.094 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 713.396 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 713.396 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 729.016 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 741.703 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 741.964 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 848 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 967.792 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 983.093 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 983.093 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 998.712 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1014.01 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1014.01 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1029.63 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1044.94 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1044.94 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1060.55 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 848.253 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 863.554 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 863.554 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 879.174 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 894.476 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 894.476 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 910.094 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 925.396 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 925.396 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 941.016 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 953.703 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 953.964 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 1060 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1179.79 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1195.09 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1195.09 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1210.71 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1226.01 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1226.01 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1241.63 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1256.94 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1256.94 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1272.55 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1060.25 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1075.55 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1075.55 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1091.17 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1106.48 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1106.48 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1122.09 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1137.4 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1137.4 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1153.02 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1165.7 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1165.96 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 1272 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1391.79 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1407.09 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1407.09 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1422.71 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1438.01 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1438.01 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1453.63 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1468.94 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1468.94 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1484.55 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1272.25 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1287.55 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1287.55 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1303.17 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1318.48 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1318.48 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1334.09 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1349.4 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1349.4 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1365.02 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1377.7 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1377.96 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 1483 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1602.79 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1618.09 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1618.09 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1633.71 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1649.01 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1649.01 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1664.63 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1679.94 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1679.94 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1695.55 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1483.25 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1498.55 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1498.55 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1514.17 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1529.48 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1529.48 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1545.09 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1560.4 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1560.4 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1576.02 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1588.7 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1588.96 8.53979)" fill="white"/>
<rect width="74" height="226" transform="matrix(0 1 1 0 1694 0)" fill="#E4002B"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1813.79 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1829.09 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1829.09 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1844.71 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1860.01 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1860.01 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1875.63 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1890.94 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1890.94 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1906.55 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1694.25 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1709.55 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1709.55 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1725.17 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1740.48 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1740.48 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1756.09 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1771.4 53.5891)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1771.4 8.57275)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1787.02 30.7617)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1799.7 53.5095)" fill="white"/>
<ellipse cx="6.34057" cy="6.37544" rx="6.34057" ry="6.37544" transform="matrix(0 1 1 0 1799.96 8.53979)" fill="white"/>
</svg>
    </div>
      
  </section>
  
</template>



<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'HeroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      currentTitleIndex: 0,
      titleInterval: null as NodeJS.Timeout | null,
      displayedText: '',
      isDeleting: false,
      isTyping: false,
    };
  },

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
    bannerText(): number {
      return Number(this.vars.bannerText);
    },
    items() {
      return this.groupedVariables.items;
    },

    currentTitle() {
      if (this.vars.title1Html && this.vars.title2Html) {
        return this.currentTitleIndex === 0 ? this.vars.title1Html : this.vars.title2Html;
      }
      return this.vars.titleHtml || '';
    },
  },

  mounted() {
    this.startTitleAnimation();
    this.initializeDisplay();
  },

  beforeUnmount() {
    this.stopTitleAnimation();
  },

  methods: {
    initializeDisplay() {
      if (this.variant === this.variants.v2 && this.vars.title1Html) {
        this.displayedText = this.vars.title1Html;
      } else {
        this.displayedText = this.vars.titleHtml || '';
      }
    },

    startTitleAnimation() {
      // Only start animation for v2 variant and if we have both titles
      if (this.variant === this.variants.v2 && this.vars.title1Html && this.vars.title2Html) {
        this.titleInterval = setInterval(() => {
          this.animateToNextTitle();
        }, 7000); // Change every 4 seconds
      }
    },

    animateToNextTitle() {
      if (this.isTyping) return; // Prevent overlapping animations

      this.isTyping = true;
      this.deleteCurrentText(() => {
        this.currentTitleIndex = (this.currentTitleIndex + 1) % 2;
        this.typeNewText(() => {
          this.isTyping = false;
        });
      });
    },

    deleteCurrentText(callback: () => void) {
      this.isDeleting = true;
      const currentHtml = this.displayedText;

      // Strip HTML tags to get plain text for character counting
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = currentHtml;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';

      let currentLength = plainText.length;

      const deleteInterval = setInterval(() => {
        if (currentLength <= 0) {
          clearInterval(deleteInterval);
          this.displayedText = '';
          this.isDeleting = false;
          callback();
          return;
        }

        // Calculate how much of the original HTML to show based on character count
        const targetLength = currentLength - 1;
        this.displayedText = this.truncateHtmlToLength(currentHtml, targetLength);
        currentLength--;
      }, 20); // Delete speed
    },

    typeNewText(callback: () => void) {
      const targetHtml = this.currentTitle;

      // Strip HTML tags to get plain text for character counting
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = targetHtml;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';

      let currentLength = 0;

      const typeInterval = setInterval(() => {
        if (currentLength >= plainText.length) {
          clearInterval(typeInterval);
          this.displayedText = targetHtml;
          callback();
          return;
        }

        currentLength++;
        this.displayedText = this.truncateHtmlToLength(targetHtml, currentLength);
      }, 40); // Type speed
    },

    truncateHtmlToLength(html: string, targetLength: number): string {
      if (targetLength <= 0) return '';

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const textContent = tempDiv.textContent || tempDiv.innerText || '';

      if (targetLength >= textContent.length) return html;

      // Simple truncation - for more complex HTML, you might need a more sophisticated approach
      const targetText = textContent.substring(0, targetLength);

      // Try to preserve some HTML structure
      let result = '';
      let textSoFar = '';
      let inTag = false;

      for (let i = 0; i < html.length; i++) {
        const char = html[i];

        if (char === '<') {
          inTag = true;
          result += char;
        } else if (char === '>') {
          inTag = false;
          result += char;
        } else if (inTag) {
          result += char;
        } else {
          if (textSoFar.length < targetLength) {
            result += char;
            textSoFar += char;
          } else {
            break;
          }
        }
      }

      return result;
    },

    stopTitleAnimation() {
      if (this.titleInterval) {
        clearInterval(this.titleInterval);
        this.titleInterval = null;
      }
    },
  },

  watch: {
    variant() {
      // Restart animation when variant changes
      this.stopTitleAnimation();
      this.initializeDisplay();
      this.startTitleAnimation();
    },
  },
});
</script>

